// extracted by mini-css-extract-plugin
export default {"wix-offering-style":"_1hra277","wixOfferingStyle":"_1hra277"};